import React, { useEffect, useState } from 'react';
import Wrapper from './styles'; // Use same styled wrapper for consistency
import { PageHero } from '../../components';
import { useLocation } from 'react-router-dom';

const ContactPage = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = 'Diy World | Contact';

    // Scroll to section if hash exists in URL (like /contact#shipping-section)
    const hash = location.hash;
    if (hash) {
      const sectionId = hash.replace('#', '');
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    agree: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.agree) {
      alert('Please agree to the terms and conditions.');
      return;
    }

    // Placeholder: Add API or email service integration here
    alert('Message sent!');
    setFormData({
      name: '',
      email: '',
      message: '',
      agree: false,
    });
  };

  return (
    <main>
  <PageHero title='Contact' />
  <Wrapper>
    <div className="form-container">

      
      <div className="title">
        <h2>Get In Touch</h2>
        <div className="underline"></div>
      </div>
      <form>
        <div>
          <label htmlFor="name">Name:</label>
          <input type="text" id="name" name="name" required />
        </div>
        <div>
          <label htmlFor="email">Email:</label>
          <input type="email" id="email" name="email" required />
        </div>
        <div>
          <label htmlFor="message">Message:</label>
          <textarea id="message" name="message" required />
        </div>
        <div className="terms">
  <input type="checkbox" id="terms" name="agree" checked={formData.agree} onChange={handleChange} />
  <label htmlFor="terms">
    I agree to the <a href="#">terms and conditions</a>
  </label>
</div>

        <button type="submit">Send Message</button>
      </form>
    </div>

    <div
  style={{
    marginTop: '2rem',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    marginBottom: '1rem'
  }}
>
  <a
    href="#shipping-section"
    style={{
      color: '#fff',
      backgroundColor: '#007BFF',
      padding: '8px 16px',
      borderRadius: '25px',
      textDecoration: 'none',
      fontWeight: 500,
      transition: 'all 0.3s ease',
      fontSize: '0.95rem',
      marginRight: '1rem'
    }}
  >
    Shipping and Delivery policy
  </a>
  <a
    href="#refund-section"
    style={{
      color: '#fff',
      backgroundColor: '#007BFF',
      padding: '8px 16px',
      borderRadius: '25px',
      textDecoration: 'none',
      fontWeight: 500,
      transition: 'all 0.3s ease',
      fontSize: '0.95rem',
      marginRight: '1rem'
    }}
  >
    Refund and Cancellation Policy
  </a>
  <a
    href="#terms-section"
    style={{
      color: '#fff',
      backgroundColor: '#007BFF',
      padding: '8px 16px',
      borderRadius: '25px',
      textDecoration: 'none',
      fontWeight: 500,
      transition: 'all 0.3s ease',
      fontSize: '0.95rem'
    }}
  >
    Terms & Conditions
  </a>
  <a
    href="#privacy-section"
    style={{
      color: '#fff',
      backgroundColor: '#007BFF',
      padding: '8px 16px',
      borderRadius: '25px',
      textDecoration: 'none',
      fontWeight: 500,
      transition: 'all 0.3s ease',
      fontSize: '0.95rem'
    }}
  >
    Privacy Policy
  </a>
</div>

    <div className="terms-section" id="terms-section">
  <h3>Terms & Conditions</h3>
  <div style={{ maxHeight: '300px', overflowY: 'auto', paddingRight: '10px' }}>
    <p><strong>Welcome to Diy World!</strong></p>

    <p>
      Please read these Terms and Conditions ("Terms") carefully before using our website and purchasing products. By accessing or using our website, you agree to be bound by these Terms.
    </p>

    <h4>1. General Information</h4>
    <p>
      Diy World is an online store selling crochet items, bracelets, wool, and related handmade products.
    </p>
    <p>By placing an order, you agree to provide accurate information and follow our policies.</p>

    <h4>2. Orders and Payment</h4>
    <ul>
      <li>All orders are subject to acceptance and availability.</li>
      <li>We reserve the right to cancel or refuse any order for reasons including but not limited to product unavailability or errors in pricing.</li>
      <li>Payment must be completed at checkout. We accept [list payment methods, e.g., credit cards, PayPal, etc.].</li>
      <li>Prices are subject to change without prior notice.</li>
    </ul>
    <br></br>

    <h4>3. Shipping and Delivery</h4>
    <ul>
      <li>We aim to process and ship your order within 7 business days.</li>
      <li>Delivery times may vary depending on your location and shipping method.</li>
      <li>Shipping charges, if any, will be displayed during checkout.</li>
    </ul>
    <br></br>

    <h4>4. Returns and Refunds</h4>
    <ul>
      <li>Due to the handmade nature of our products, returns or exchanges are accepted only if items are damaged or defective.</li>
      <li>Please contact us within 2 days of receiving your order to request a return or exchange.</li>
      <li>Refunds will be processed after the item is returned and inspected.</li>
    </ul>
    <br></br>

    <h4>5. Product Descriptions</h4>
    <p>
      We strive to display accurate colors and details, but actual product appearance may vary slightly due to screen settings and handmade variations.
      Each item is unique; slight differences may occur.
    </p>

    <h4>6. User Conduct</h4>
    <p>
      You agree to use our website only for lawful purposes.
      You must not engage in any activity that could harm, disrupt, or interfere with our website or services.
    </p>

    <h4>7. Privacy</h4>
    <p>
      We respect your privacy. Please review our Privacy Policy to understand how we collect, use, and protect your information.
    </p>

    <h4>8. Intellectual Property</h4>
    <p>
      All content on the website, including images, descriptions, logos, and designs, is owned by Diy World or its licensors.
      You may not use, copy, or distribute our content without permission.
    </p>

    <h4>9. Limitation of Liability</h4>
    <p>
      We are not liable for any damages arising from the use of our products or website.
      We do not guarantee the availability or accuracy of the website at all times.
    </p>

    <h4>10. Changes to Terms</h4>
    <p>
      We reserve the right to update these Terms at any time.
      Changes will be posted on this page, and continued use of the website means you accept the updated Terms.
    </p>

    <h4>11. Contact Us</h4>
    <p>
      If you have any questions about these Terms, please contact us at:<br />
      Email: parmarayush988@gmail.com<br />
      Phone: +91 93135 85969
    </p>
  </div>
</div>

<div className="refund-section" id="refund-section">
  <h3>Refund and Cancellation Policy</h3>
  <div style={{ maxHeight: '300px', overflowY: 'auto', paddingRight: '10px' }}>
    <p><strong>Welcome to Diy World!</strong></p>

    <p>
        Upon completing a Transaction, you are entering into a legally binding and enforceable agreement with us to purchase the product and/or service. After this point the User may cancel the Transaction unless it has been specifically provided for on the Platform. In which case, the cancellation will be subject to the terms mentioned on the Platform. We shall retain the discretion in approving any cancellation requests and we may ask for additional details before approving any requests. Once you have received the product and/or service, the only event where you can request for a replacement or a return and a refund is if the product and/or service does not match the description as mentioned on the Platform. Any request for refund must be submitted within three days from the date of the Transaction or such number of days prescribed on the Platform, which shall in no event be less than three days. A User may submit a claim for a refund for a purchase made, by raising a ticket here or contacting us on seller+5fe81f2271a54fef960dfe0757835484@instamojo.com and providing a clear and specific reason for the refund request, including the exact terms that have been violated, along with any proof, if required. Whether a refund will be provided will be determined by us, and we may ask for additional details before approving any requests.
        </p>
  </div>
</div>

<div className="shipping-section" id="shipping-section">
  <h3>Shipping and Delivery policy</h3>
  <div style={{ maxHeight: '300px', overflowY: 'auto', paddingRight: '10px' }}>
    <p><strong>Welcome to Diy World!</strong></p>

    <p>
        
        You hereby agree that the delivery dates are estimates, unless a fixed date for the delivery has been expressly agreed in writing. The cost for delivery shall be calculated at the time of initiation of Transaction based on the shipping address and will be collected from you as a part of the Transaction Amount paid for the products and/or services. In the event that you do not receive the delivery even after seven days have passed from the estimated date of delivery, you must promptly reach out to us at seller+5fe81f2271a54fef960dfe0757835484@instamojo.com.
        
        </p>
  </div>
</div>

<div className="privacy-section" id="privacy-section">
  <h3>Privacy Policy</h3>
  <div style={{ maxHeight: '300px', overflowY: 'auto', paddingRight: '10px' }}>
    <p><strong>Welcome to Diy World!</strong></p>

    <p>
      At Diy World, we are committed to protecting your privacy and ensuring that your personal information is handled in a safe and responsible manner.
    </p>

    <p>
      When you visit our website, we may collect certain personal data such as your name, email address, contact details, and other information you choose to provide. This information is used to fulfill your requests, provide our services, and improve your experience.
    </p>

    <p>
      We do not share, sell, rent, or trade your personal information with third parties for their commercial purposes. However, we may share your data with trusted partners who assist us in operating our website or servicing you, so long as those parties agree to keep this information confidential.
    </p>

    <p>
      We implement a variety of security measures to maintain the safety of your personal information. Your data is stored on secure servers and is only accessible by a limited number of authorized personnel.
    </p>

    <p>
      By using our website, you consent to our Privacy Policy. If we make changes to this policy, we will post the updated version here. For any concerns or questions, please contact us at: <strong>diyworld988@gmail.com</strong>
    </p>
  </div>
</div>




  </Wrapper>
</main>

  );
};

export default ContactPage;
